<template>
  <section class="preview-pane flex-grow-1 d-flex flex-column h-100" style="display: flex; flex-direction: column">
    <template v-if="$route.path == '/'">
      <template v-if="isLoadingReferrals">
        <ReferralTopBar />
        <ReferralLoader />
      </template>
      <div v-else class="d-flex align-items-center justify-content-center h-100">
        <!-- <h3 class="mb-0 text-hint" v-if="!all.length">No referrals screen</h3>
        <h3 class="mb-0 text-hint">No needs action screen</h3> -->
        <empty
          v-if="!all.length"
          heading="Woohoo!"
          :cta="user.practice.specialty == 0 ? 'Create referral' : 'Create op report'"
          :link="user.practice.specialty == 0 ? '/referral/create' : '/op-report/create'"
          :image="require('../../assets/svg/no-op-reports.svg')"
        >
          Sit back, relax and enjoy the magic of Refera<br />
          We'll notify you when action is needed</empty
        >
      </div>
    </template>
    <template v-else>
      <ReferralTopBar :referralId="referralId" @send="sendClick" :isSaving="isSaving" />
      <ReferralEditor
        ref="referralEditor"
        v-if="isEditor"
        :showSidebar="true"
        :showSendModal="isConfirmationModalVisible"
        @closeSendModal="isConfirmationModalVisible = false"
        @isSaving="isSaving = $event"
        style="overflow: auto"
      />
      <ReferralPreview v-else :item="referral" style="overflow: auto" />

      <success-modal
        v-if="referral && isSuccessModalShown"
        @close="isSuccessModalShown = false"
        :message="`This referral has been delivered to ${referral.to_practice && referral.to_practice.name}`"
      />
    </template>
  </section>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import ReferralPreview from '@/components/referrals/inbox/ReferralPreview'
import ReferralTopBar from '@/components/referrals/inbox/ReferralTopBar'
import ReferralLoader from '@/components/referrals/inbox/ReferralLoader'
import ReferralEditor from '@/views/referrals/ReferralEditor'
import Empty from '@/components/shared/Empty.vue'
import SuccessModal from '../../components/shared/SuccessModal.vue'
export default {
  props: {
    showIncoming: { default: true },
  },
  components: {
    ReferralPreview,
    ReferralEditor,
    ReferralTopBar,
    ReferralLoader,
    Empty,
    SuccessModal,
  },
  data() {
    return {
      isConfirmationModalVisible: false,
      isLoadingReferrals: false,
      isSaving: false,
    }
  },
  async created() {
    this.isLoadingReferrals = true
    if (!this.$store.state.referrals.isLoaded) {
      await this.$store.dispatch('referrals/load')
    }
    this.isLoadingReferrals = false
    if (!this.referralId && this.all.length && !this.$route.query.to && !this.activeTour) {
      this.$router.push('/referral/' + this.all[0].id)
    }
  },
  async mounted() {},
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isLoggedIn', 'isOrganization']),
    ...mapState('tour', ['activeTour']),
    ...mapGetters('tour', ['currentTarget']),
    ...mapGetters('referrals', ['all', 'get']),
    ...mapState('referrals', [
      'isLoaded',
      'isLoading',
      'searchTerm',
      'error',
      'referrals',
      'contextPracticeId',
      'activeFilter',
    ]),
    referralId() {
      return this.$route.params?.id
    },
    referral() {
      return this.referralId && this.get(this.referralId)
    },
    isEditor() {
      return !this.referral?.sent_time
    },
    isRequestForUpdateModalShown() {
      const r = this.referral
      return r && r.is_incoming && r.patient_called_on && !r.snooze_until_to_time && !r.is_marked_scheduled
    },
    isSuccessModalShown: {
      get() {
        return this.$store.state.referrals.isSuccessModalShown
      },
      set(val) {
        this.$store.dispatch('referrals/setIsSuccessModalShown', val)
      },
    },
  },
  methods: {
    async sendClick() {
      this.$refs.referralEditor.configureValidation({
        events: 'change|input|blur',
      })
      const isValid = await this.$refs.referralEditor.validate()
      if (isValid) this.isConfirmationModalVisible = true
      if (this.currentTarget == '[data-v-tour="sendReferral"]') this.$store.dispatch('tour/next')
    },
  },
  // async beforeRouteEnter(to, from, next) {
  //   if (to.query.to) {
  //     const referring_doctor_id =
  //       store.state.auth.user.practice.doctors.length &&
  //       store.state.auth.user.practice.doctors[0].id
  //     const r = await store.dispatch('referrals/save', {
  //       to_practice_id: to.query.to,
  //       referring_doctor_id,
  //     })
  //     next('/referral/' + r.id)
  //   } else next()
  // },
}
</script>